import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "q-pa-lg",
  style: {"border-radius":"8px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "text-body1 text-weight-bolder text-grey-8" }
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "text-caption text-grey-6" }
const _hoisted_9 = { class: "row q-mt-md" }
const _hoisted_10 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_badge = _resolveComponent("q-badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.subject), 1),
          _createVNode(_component_q_space),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_q_badge, {
              class: "text-bold q-pa-sm",
              color: "grey-4",
              "text-color": "grey-9"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Valor: " + _toDisplayString(_ctx.totalScore) + " pts", 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.datetime), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_q_badge, {
          class: "q-pa-sm text-bold q-mr-md",
          style: {"font-size":"15px"},
          color: "blue-1",
          "text-color": "blue-7"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Linhas escritas: " + _toDisplayString(_ctx.linesFormatted), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_q_badge, {
          class: "q-pa-sm text-bold",
          style: {"font-size":"15px"},
          color: "blue-1",
          "text-color": "blue-7"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Pontuação: " + _toDisplayString(_ctx.userScore), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}